<figure class="c-media">
  <div class="c-media__placeholder is-16:9" role="img">
    <iframe width="560" height="315" [src]="url" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
            [title]="component.content.title"></iframe>
  </div>
  <figcaption *ngIf="component.content.description">{{component.content.description}}</figcaption>
</figure>
